import React from "react";
import { createHashRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Home from "../pages/Home";
import Layout from "./generalStructure/Layout/Layout";
import Ingreso from "../pages/Login";
import Turno from "../pages/Turno";
// Create the router configuration
const router = createHashRouter([
  {
    path: "/",
    element: (
      
        <Layout>
          <Ingreso />
        </Layout>
      
    ),
    index: true,
  },
  
  {
    path: "/Turno/:id",
    element: (
      
        <Layout titulo="Pago de Reserva">
          <Turno />
        </Layout>
      
    ),
    index: true,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/Home",
        element: (
          
            <Layout titulo="Mis Reservas">
            <Home />
            </Layout>
          
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <p style={{ textAlign: "center", textTransform: "capitalize" }}>
        no se encontró el sitio
      </p>
    ),
  },
]);

export default router;
